import { useSnackbar } from 'notistack';
import useI18n, { Ti18nId } from './useI18n';

const useNotification = () => {
  const i18n = useI18n();
  const { enqueueSnackbar } = useSnackbar();

  const toErrorText = (e: unknown) => {
    if (e instanceof Error) return e.message;
    try {
      return typeof e === 'string' ? e : JSON.stringify(e);
    } catch {
      return String(e);
    }
  };

  const onSuccess = (message: string) => {
    enqueueSnackbar(message, { variant: 'success' });
  };

  const onResultCode = (rc: number) => {
    // valid error codes
    const errorCodes = [
      100, 101, 102, 104, 105, 106, 107, 108, 111, 201, 202, 702,
    ];
    // error message
    const message = errorCodes.includes(rc)
      ? i18n(`ERROR.CODE.${rc}` as Ti18nId)
      : i18n(`ERROR.CODE.0`, { rc });

    return enqueueSnackbar(message, { variant: 'error' });
  };

  const onFail = (message: string, e: unknown) => {
    enqueueSnackbar(
      `${message} Please try again later.\nError: ${toErrorText(e)}`,
      { variant: 'error' }
    );
  };

  const onBeforeSearch = (message: string) => {
    enqueueSnackbar(
      `${message}\nPlease set the year and sort order, then click the Search button.`,
      { variant: 'error' }
    );
  };

  const onAccountFail = (message: string) => {
    enqueueSnackbar(`${message}\nRedirecting to the login screen.`, {
      variant: 'error',
    });
  };

  const onRequired = (id: Ti18nId) => {
    enqueueSnackbar(i18n(id), { variant: 'error' });
  };

  return {
    onSuccess,
    onFail,
    onResultCode,
    onRequired,
    onBeforeSearch,
    onAccountFail,
  };
};

export default useNotification;
